import {  Dialog, DialogContent, DialogTitle, IconButton, Typography,  } from "@mui/material";
  
  const PlanStatusDialogWeb = ({ open, onClose, planName, status = "success" }) => {
    const isSuccess = status === "success";
  
    const iconColor = isSuccess ? "#00c853" : "#ff1744";
    const iconClass = isSuccess ? "fa-check-circle" : "fa-times-circle";
    const title = isSuccess ? "Congratulations! " : "Payment Failed";
    const message = isSuccess
      ? `You have successfully subscribed to ${planName ?? "the plan"}.`
      : "Something went wrong. Please try again.";
  
    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="plan-status-dialog-title"
        PaperProps={{
          style: {
            backgroundColor: "#1a1c24",
            color: "white",
            padding: "20px",
            borderRadius: "12px",
            position: "relative",
          },
        }}
      >
        {/* Close Icon */}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 10, right: 10, color: "white" }}
        >
          <i className="fa fa-times" style={{ fontSize: "24px" }}></i>
        </IconButton>
  
        {/* Icon */}
        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          <div
            style={{
              background: "#2a2c35",
              borderRadius: "20px",
              width: "64px",
              height: "64px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i
              className={`fa ${iconClass}`}
              style={{ fontSize: "32px", color: iconColor }}
            ></i>
          </div>
        </div>
  
        {/* Title */}
        <DialogTitle
          id="plan-status-dialog-title"
          sx={{ textAlign: "center", paddingBottom: 0 }}
        >
          <Typography variant="h6" fontWeight="bold">
            {title}
          </Typography>
        </DialogTitle>
  
        {/* Message */}
        <DialogContent sx={{ textAlign: "center", color: "#a0a0a0" }}>
          <Typography>{message}</Typography>
        </DialogContent>
      </Dialog>
    );
  };
  
  export default PlanStatusDialogWeb;
  